import Loading from 'components/Loading';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams, useLocation } from 'react-router-dom';
import * as yup from 'yup';
import Fields from './Fields';
import { toast } from 'react-toastify';
import { newMissionCategory } from 'services/mission.routes';
import { updateMissionCategory } from 'services/mission.routes';
import queryString from 'utils/queryString';

export default function NewMissionCategory() {
    const [loading, setLoading] = useState(false);
    const [information, setInformation] = useState({});
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const method = searchParams.get("method");
    const { state } = useLocation();

    const schema = yup.object().shape({
        name: yup.string().required(),
        access_level: yup.string().required(),
        level: yup.number().required(),
    });

    useEffect(() => {
        if (state) {
            setInformation({
                name: state.name,
                access_level: state.access_level,
                level: state.level,
            });
        }
    }, [state]);

    const handleCategoryChanges = async () => {
        if (state.id) {
            let data = {};
            for (let item in information) {
                if (information[item]) {
                    data[item] = information[item];
                }
            }
            setLoading(true)
            updateMissionCategory(state.id, queryString(data), (isOk, data) => {
                setLoading(false)
                if (!isOk) {
                    return toast.error(data.message);
                } else {
                    toast.success(`دسته بندی ویرایش شد`);
                    navigate('/mission-category')
                }
            });
        }
    };

    const handleNewCategory = () => {
        schema
            .validate(information)
            .then(async (res) => {
                if (res) {
                    let data = {};
                    for (let item in information) {
                        if (information[item]) {
                            data[item] = information[item];
                        }
                    }
                    setLoading(true)
                    newMissionCategory(queryString(data), (isOk, data) => {
                        setLoading(false)
                        if (!isOk) {
                            return toast.error(data.message);
                        } else {
                            toast.success(`دسته بندی اضافه شد`);
                            navigate('/mission-category')
                        }
                    });
                }
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.errors[0]);
            });
    };
    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Loading loading={loading} />
            <p style={{ fontSize: 16, fontWeight: "bold" }}>{method !== "update" ? "دسته بندی جدید" : "ویرایش دسته بندی"}</p>
            <Fields information={information} handleUpdate={handleCategoryChanges} method={method} setInformation={setInformation} submit={handleNewCategory} />
        </DashboardLayout>
    )
}
